import React from "react";

export default function ProductFilter({
  categories = [],
  filters,
  onChange,
}) {
  return (
    <div className="grid gap-3 md:grid-cols-3">
      <select
        value={filters.category}
        onChange={(event) => onChange("category", event.target.value)}
        className="rounded-2xl border border-gray-300 bg-white px-4 py-3 text-sm outline-none focus:border-orange-500"
      >
        <option value="all">Semua kategori</option>
        {categories.map((category) => (
          <option key={category.slug} value={category.slug}>
            {category.name}
          </option>
        ))}
      </select>

      <select
        value={filters.stock}
        onChange={(event) => onChange("stock", event.target.value)}
        className="rounded-2xl border border-gray-300 bg-white px-4 py-3 text-sm outline-none focus:border-orange-500"
      >
        <option value="all">Semua stok</option>
        <option value="ready">Stok tersedia</option>
        <option value="empty">Stok habis</option>
      </select>

      <select
        value={filters.sort}
        onChange={(event) => onChange("sort", event.target.value)}
        className="rounded-2xl border border-gray-300 bg-white px-4 py-3 text-sm outline-none focus:border-orange-500"
      >
        <option value="featured">Unggulan</option>
        <option value="newest">Terbaru</option>
        <option value="popular">Terlaris</option>
        <option value="rating">Rating tertinggi</option>
        <option value="price_asc">Harga terendah</option>
        <option value="price_desc">Harga tertinggi</option>
        <option value="name_asc">Nama A-Z</option>
        <option value="name_desc">Nama Z-A</option>
      </select>
    </div>
  );
}
